import {
  addExtra,
  getDocumentacion as axiosGetDocumentacion,
  getOtherFiles as axiosGetOtherFiles,
} from '../../../axios/Reintegro/Documentacion';
import {
  GET_DOCUMENTACION_EXISTENTE,
  GET_OTHER_FILES,
} from '../../../axios/Utils/constants';
import { Documentacion } from '../../../types/Reintegro/types';
import { convertToBlob } from '../../../utils/blob';
import { DOCUMENT_HANDLERS, TYPE_MAP } from '../../../utils/documentacion';
import { compressImg } from '../../../utils/imgCompression';
import { useFetchEntity } from '../../Utils/useEntity';

const useDocumentacion = () => {
  const postDocumento = async (
    siniestroId: string,
    type: keyof typeof DOCUMENT_HANDLERS,
    photo: string | Blob,
    mutate?: () => Promise<any>,
  ) => {
    let blob = await convertToBlob(photo);
    blob = await compressImg(blob);

    const fd = new FormData();
    fd.append(TYPE_MAP[type] || 'file', blob);
    fd.append(type === 'constancia' ? 'label' : 'tipo', type);
    fd.append('siniestroId', siniestroId);

    await DOCUMENT_HANDLERS[type](fd);
    await mutate?.();
  };

  return { postDocumento };
};

const postDocumentacionOtros = async (
  file: File | string,
  siniestroId: string,
  mutate?: () => Promise<any>,
  label: string = 'comprobante_pago',
) => {
  try {
    let blob = await convertToBlob(file);
    blob = await compressImg(blob);

    const fd = new FormData();
    fd.append('doc_extra', blob);
    fd.append('siniestroId', siniestroId);
    fd.append('label', label);

    await addExtra(fd);
    await mutate?.();
    return true;
  } catch (err) {
    return null;
  }
};

const useGetDocumentacion = (siniestroId?: string) => {
  const shouldFetch = Boolean(siniestroId);

  const key = shouldFetch ? `${GET_DOCUMENTACION_EXISTENTE}-${siniestroId}` : null;

  const { data, error, isValidating, mutate } = useFetchEntity<Documentacion>(
    key,
    async () => {
      const res = await axiosGetDocumentacion(siniestroId);
      return res.data;
    },
  );

  return { documentacion: data, isValidating, error, mutate };
};

const useGetOtherFiles = (siniestroId?: string, label?: string) => {
  const key = siniestroId && label ? `${GET_OTHER_FILES}-${siniestroId}-${label}` : null;

  const { data, error, isValidating, mutate } = useFetchEntity<any[]>(
    key,
    async () => {
      const res = await axiosGetOtherFiles(siniestroId!, label!);
      return res.data ?? [];
    },
  );

  // isLoading: true solo en la primera carga (data undefined), no en revalidaciones
  const isLoading = isValidating && data === undefined;

  return { otherFiles: data ?? [], isValidating, isLoading, error, mutate };
};

export {
  useDocumentacion,
  postDocumentacionOtros,
  useGetDocumentacion,
  useGetOtherFiles,
};
